<template>
  <div class="col-md-12">
    <br />
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Type:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name="Type" v-model="encodingData.Type" class="form-control">
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.transportationType"
              v-bind:key="option.transportationType"
            >
              {{ option.transportationType }}
            </option>
          </select>
        </div>
      </div>
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >PrincipalId :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="PrincipalId"
            v-validate="'max:50'"
            v-model="encodingData.PrincipalId"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('PrincipalId') }" />
                    <div v-if="submitted && errors.has('PrincipalId')"
                         class="invalid-feedback">
                        {{ errors.first("PrincipalId") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Name :</label
        >
        <div class="col-md-6 col-sm-6">
          <input name="Name"
          v-validate="'max:50'"
          v-model="encodingData.Name" 
          class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('Name') }" />
                    <div v-if="submitted && errors.has('Name')"
                         class="invalid-feedback">
                        {{ errors.first("Name") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Motor/Chassis No :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="AdditionalId"
            v-validate="'max:50'"
            v-model="encodingData.AdditionalId"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('AdditionalId') }" />
                    <div v-if="submitted && errors.has('AdditionalId')"
                         class="invalid-feedback">
                        {{ errors.first("AdditionalId") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Make :</label
        >
        <div class="col-md-6 col-sm-6">
          <input name="Make"
          v-validate="'max:50'"
          v-model="encodingData.Make" 
          class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('Make') }" />
                    <div v-if="submitted && errors.has('Make')"
                         class="invalid-feedback">
                        {{ errors.first("Make") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Model :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Model"
            v-validate="'max:50'"
            v-model="encodingData.Model"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('Model') }" />
                    <div v-if="submitted && errors.has('Model')"
                         class="invalid-feedback">
                        {{ errors.first("Make") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >ModelYear :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="number"
            v-validate="'max:50'"
            name="ModelYear"
            v-model="encodingData.ModelYear"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('ModelYear') }" />
                    <div v-if="submitted && errors.has('ModelYear')"
                         class="invalid-feedback">
                        {{ errors.first("ModelYear") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Color :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Color"
            v-validate="'max:50'"
            v-model="encodingData.Color"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('Color') }" />
                    <div v-if="submitted && errors.has('Color')"
                         class="invalid-feedback">
                        {{ errors.first("Color") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="Country"
            v-model="encodingData.Country"
            class="form-control"
          >
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopTE" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  checkLinkMode,
  getlocalstorageTransportationType,
  getlocalstorageCountry,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Type: "",
        PrincipalId: "",
        Name: "",
        AdditionalId: "",
        Make: "",
        Model: "",
        ModelYear: "",
        Color: "",
        Country: "",
        Comments: "",
      },
      countries: [],
      types: [],
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      let loader = this.$loading.show();
      instance
        .post(EncodeURL + "newTransportation", this.encodingData, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error) {
            loader.hide();
            notifyHelper(
              "error",
              "There was an error processing your request!"
            );
          } else {
            loader.hide();
            notifyHelper("success", "Saved");
            //this.clearControls()
            if (checkLinkMode()) {
              if (confirm("Link this newly created entity?")) {
                setObject2Link(response.data.id, "TR");
                this.setLink(response.data.id);
              }
            }
          }
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.types = getlocalstorageTransportationType();
    },
    setLink: function (id) {
      setObject2Link(id, "TR");
      this.$bvModal.show("LinkPopTR");
    },
    clearControls() {
      this.encodingData.PrincipalId = "";
      this.encodingData.Type = "";
      this.encodingData.Name = "";
      this.encodingData.AdditionalId = "";
      this.encodingData.Make = "";
      this.encodingData.Model = "";
      this.encodingData.ModelYear = "";
      this.encodingData.Color = "";
      this.encodingData.Country = "";
      this.encodingData.Comments = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>

